import React, {PropsWithChildren, useEffect} from "react";
import ReactDOM from 'react-dom';
import {observer} from "mobx-react";
import styled from "styled-components";
import {ZIndex} from "../../../../../types/z-index";
import {IDropDownController} from "../../models/drop-down-controller.interface";
import {isClickInsideElement} from "../../../../../utils/is-click-inside-element";
import {CardBox} from "../../../../../basic-components/card/card.box";
import {useServices} from "../../../../../hooks/use-services.hook";


const DropDownFixedContainerBox = styled(CardBox)`
    box-sizing: border-box;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translateY(-50%) translateX(-50%);
    z-index: ${ZIndex.DropDownPopper + 10};
    box-shadow: ${props => props.theme.boxShadow.shadow6};
    padding: 0;
    overflow: hidden;
    border-radius: ${props => props.theme.border.radiusPx(2)};
    & * {
        box-sizing: border-box;
        line-height: 1;
    }
`

interface DropDownFixedPositionComponentProps  extends  PropsWithChildren{
    dropDownController: IDropDownController;
}
export const DropDownFixedPositionComponent: React.FC<DropDownFixedPositionComponentProps> = observer((props) => {
    const services = useServices();
    const containerRef = React.useRef<HTMLDivElement | null>(null);

    useEffect(() => {

        const el = containerRef.current;
        const onDocumentClickHandler = (event: MouseEvent) => {
            if(el && !isClickInsideElement(event, el)) {
                props.dropDownController.closeDropDown();
            }
        }

        let timeoutRef: any;

        if(el) {
            timeoutRef = setTimeout(() => {
                document.addEventListener('click', onDocumentClickHandler);
            }, 500)

        }



        return () => {
            if(el) {
                clearTimeout(timeoutRef)
                document.removeEventListener('click', onDocumentClickHandler);
            }

        };
    }, [props.dropDownController]);

    return (
        ReactDOM.createPortal((<DropDownFixedContainerBox ref={containerRef} className={"tst-drop-down-fixed"}>
            {props.children}
        </DropDownFixedContainerBox>), services.document.body)
    );
});